import { render, staticRenderFns } from "./UserLinkComponent.vue?vue&type=template&id=49a365ce&scoped=true&"
import script from "./UserLinkComponent.vue?vue&type=script&lang=js&"
export * from "./UserLinkComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserLinkComponent.vue?vue&type=style&index=0&id=49a365ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a365ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VBadge,VImg,VList,VListItem,VListItemContent,VMenu})
